import {penpotId} from '../../utils';

const genDefaultDynamicCss = (): DynamicCss[] => ([{
  type: 'default',
  bind: 'default',
  sources: [{
    value: 'default',
    expression: 'eq',
    action: 'cover',
    css: {
      normal: {
        "position": "relative",
        "left": "left-0",
        "top": "top-0",
        "width": "w-325",
        "height": "h-200"
      }
    },
  }],
}, {
  type: 'status',
  bind: 'status',
  sources: [
    {value: 'hover', expression: 'eq', action: 'merge', css: {variants: {}}},
    {value: 'focus', expression: 'eq', action: 'merge', css: {variants: {}}},
    {value: 'active', expression: 'eq', action: 'merge', css: {variants: {}}},
    {value: 'visited', expression: 'eq', action: 'merge', css: {variants: {}}},
  ],
}]);

const root = {
  type: 'frame',
  prop: 'root',
  parent: '',
  children: [],
  dynamicCss: genDefaultDynamicCss(),
  event: {},
  attrs: {
    title: {
      label: '标题',
      type: 'string',
      value: 'root',
    },
  },
  hook: {},
  comps: {
    subject: 'custom-atom-frame',
    configuration: 'custom-atom-frame-config',
  },
}

/**
 * @description: 页面配置的AST
 * @return {*}
 */


export class ComponentDesignAST {
  _id: string = penpotId();
  components: ComponentItem[] = [root];
  domainModelCode: string = "";
  title: string = "新建组件";
  tailwindStyleCodes: string = "";
  publish?: "DRAFT" | "PUBLISH" | "DEACTIVATE" = "DRAFT";
  createTime?: string = "";
  lastModifyTime?: string = "";
  createUser?: string = "";
  lastModifyUser?: string = "";
  page_desc?: string = "";
  comment?: string = "";
  pureFunction?: any = {};
}

export class ConfigAST extends ComponentDesignAST {
  title: string = "新建页面";
  dataSources?: DataSources = new DataSources();
}

/**
 * @description: 页面中单个组件的AST
 * @return {*}
 */
export class ComponentItem {
  type: string = "";
  prop: string = "";
  parent: string = "";
  children: any[] = [];
  comps: any = {};
  css?: any = {};
  dynamicCss?: DynamicCss[] = [];
  attrs: any = {};
  event: Record<string, eventItem> = {};
  hook: Record<string, eventItem> = {};
  dataSource?: string = "";
  status?: string = "edit";
  index?: number = 0;
  desc?: string = "";
}


export class RootNode extends ComponentItem {
  type: string = "frame";
  prop: string = "root";
}


export class eventItem {
  label: string = "";
  triggerSetting: triggerSetting = new triggerSetting();
}

export class triggerSetting {
  functionBody: any[];
  customFunctionParams: any[];
  customParamsList: any[];
  maxFunctionList: any[];
}

export class PureFunctionSetting {
  customGlobalFunctionParams: any[];
  customGlobalParamsList: any[];
}


export type DynamicCssType = 'default' | 'status' | 'prop';
export type DynamicCssSourceExpression = 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte';
export type DynamicCssSourceAction = 'merge' | 'cover' | 'del' | 'add';

export interface DynamicCssSource {
  value: string;
  expression: DynamicCssSourceExpression;
  action: DynamicCssSourceAction;
  css: {
    normal?: { [cssKey: string]: string };
    variants?: { [cssKey: string]: string };
    responsive?: { [cssKey: string]: string };
  };
}

export interface DynamicCss {
  type: DynamicCssType;
  bind: 'default' | 'status' | string;
  sources: DynamicCssSource[];
}

/**
 * @description: 页面数据源配置
 * @return {*}
 */
export class DataSources {
  items: DataSourceItem[] = [];
  relationship: EdgeItem[] = [];
}

/**
 * @description: 单个数据源配置项
 * @return {*}
 */
export class DataSourceItem {
  prop: string = "";
  formId: string = "";
  label: string = "";
  type: string = "";
  notFollowTenant: boolean = false;
  notInitialize: boolean = false;
  domainCode: string = "";
  filter: any;
  paramType: 'condition' | 'data' = 'condition';
  pageSize?: number = 10;
  paginationType?: 'default'
}

/**
 * @description: 关联关系配置项
 * @return {*}
 */
export class EdgeItem {
  source: string = "";
  target: string = "";
  type: '1:N' | 'M:N' = '1:N';
}


